// Per-AWB browser-tab storage for the Manage Order page. A reload keeps the buyer's unsaved
// edits (draft) and the last order details loaded with OTP (so a reload does not depend on one
// more /otp/validate call succeeding). Both expire with the 2-hour OTP passcode.
//
// The OTP modal also writes the order details here when the buyer verifies before opening
// Manage Order, so the page opens with the customer details already loaded.

const STORE_TTL_MS = 2 * 60 * 60 * 1000;

export const draftKey = (awb) => `manageOrderDraft:${awb}`;
export const dataKey = (awb) => `manageOrderData:${awb}`;

export const readStored = (key) => {
  try {
    const value = JSON.parse(sessionStorage.getItem(key));
    if (value && Date.now() - value.at < STORE_TTL_MS) return value;
    sessionStorage.removeItem(key);
  } catch (e) {
    // Storage blocked or bad JSON: start clean.
  }
  return null;
};

export const writeStored = (key, value) => {
  try {
    sessionStorage.setItem(key, JSON.stringify({ ...value, at: Date.now() }));
  } catch (e) {
    // Storage full or blocked: the page still works, a reload just loses the draft.
  }
};

/** Full order details (from /otp/validate full-details) for Manage Order. */
export const saveOrderDetails = (awb, result) => {
  if (awb && result) writeStored(dataKey(awb), { result });
};
